<template>
  <b-container>

  </b-container>
</template>

<script>
export default {
name: "Tribunes"
}
</script>

<style scoped>

</style>